module.exports={
  "modules": {
    "cookie": {
      "require": "./lib/cookie",
      "type": "value"
    },
    "baseURL": {
      "require": "./lib/base-url",
      "type": "value"
    },
    "cx": "classnames",
    "debounce": {
      "require": "./lib/debounce",
      "type": "value"
    },
    "InfiniteScrollMixin": "./lib/infinite-scroll-mixin",
    "publicURL": {
      "require": "./lib/public-url",
      "type": "value"
    },
    "transitioner": {
      "require": "./web/transitioner",
      "type": "value"
    },
    "webUtils": {
      "require": "./lib/utils",
      "type": "value"
    }
  }
}
